module.exports = {
  GOOGLE: "Google Credentials",
  ACCOUNTS: "Accounts",
  CATEGORIES: "Categories",
  UI: "UI",
  EXTRAS: "Extras",
  GENERATE: "Generate",
};
